(() => {
  'use strict';

  function updateHolidayCollectionLink(link) {
    const destination = new URL(link.getAttribute('href'), window.location.href);
    if (destination.origin !== window.location.origin || !/\/collections\/[^/]+\/?$/.test(destination.pathname)) return;
    destination.searchParams.set('view', 'holiday');
    const activeTheme = window.Shopify?.theme;
    if (['unpublished', 'development'].includes(activeTheme?.role) && /^[1-9]\d*$/.test(String(activeTheme.id))) {
      destination.searchParams.set('preview_theme_id', String(activeTheme.id));
      const country = window.Shopify?.country;
      if (!destination.searchParams.has('country') && /^[A-Z]{2}$/.test(country || '')) destination.searchParams.set('country', country);
    }
    link.setAttribute('href', destination.pathname + destination.search + destination.hash);
  }

  function updateHolidayCollectionLinks(root = document) {
    root.querySelectorAll('[data-holiday-collection-link]').forEach(updateHolidayCollectionLink);
  }

  updateHolidayCollectionLinks();
  if (window.PFMHolidayAnalytics) return;

  document.addEventListener('shopify:section:load', (event) => updateHolidayCollectionLinks(event.target));

  const eventNames = {
    hero_cta: 'holiday_campaign_click',
    bundle_select: 'holiday_bundle_select',
    bundle_cta: 'holiday_bundle_click',
    gifts_cta: 'holiday_campaign_click',
    subscription_cta: 'holiday_subscription_click',
    quiz_start: 'holiday_quiz_start',
    quiz_complete: 'holiday_quiz_complete',
    recommendation_click: 'holiday_recommendation_click'
  };

  function track(root, interaction, values = {}) {
    if (!root || !eventNames[interaction]) return;
    const detail = {
      event: eventNames[interaction],
      campaign: 'holiday_2026',
      interaction,
      placement: root.dataset.holidaySection || 'gift_match',
      section_id: root.id || root.closest('.shopify-section')?.id || '',
      page_path: window.location.pathname
    };
    if (values.product_handle) detail.product_handle = values.product_handle;
    if (values.collection_handle) detail.collection_handle = values.collection_handle;
    if (['myself', 'partner', 'friend'].includes(values.recipient)) detail.recipient = values.recipient;
    if (['everyday', 'travel', 'date-night'].includes(values.need)) detail.need = values.need;
    if (['under-10', 'under-20', 'any'].includes(values.budget)) detail.budget = values.budget;
    // Campaign interactions only. Native Shopify/Stay.ai/Rebuy own ecommerce events.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const actionable = event.target.closest('a, button');
    const root = actionable?.closest('.pfm-holiday');
    if (!root) return;
    if (actionable.matches('[data-holiday-collection-link]')) updateHolidayCollectionLink(actionable);
    const target = actionable.closest('[data-holiday-event]');
    if (target) {
      track(root, target.dataset.holidayEvent, {
        product_handle: target.dataset.holidayProduct || target.closest('[data-holiday-product]')?.dataset.holidayProduct
      });
    }

    if (actionable.matches('a[href="#holiday-favorites"]') && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      const favorites = document.getElementById('holiday-favorites');
      if (!favorites) return;
      event.preventDefault();
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      favorites.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(history.state, '', '#holiday-favorites');
      const heading = favorites.querySelector('h2');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
    }
  });

  document.addEventListener('pfm:holiday:interaction', (event) => {
    if (!(event.target instanceof Element)) return;
    track(event.target.closest('.pfm-holiday'), event.detail?.event, event.detail || {});
  });

  window.PFMHolidayAnalytics = { track };
})();
